(() => {
  class InkRollMaterials {
    constructor(root) {
      this.root = root;
      this.group = root.querySelector('[data-roll-materials]');
      this.strings = JSON.parse(this.group.querySelector('[data-material-strings]').textContent);
      this.currency = this.group.dataset.currency || 'USD';
      this.form = document.getElementById(root.dataset.formId);
      this.variants = {};
      root.querySelectorAll('[data-material-variants]').forEach(source => {
        try {
          const variants = JSON.parse(source.textContent);
          this.variants[source.dataset.materialVariants] = Array.isArray(variants) ? variants : [];
        } catch (_error) {
          this.variants[source.dataset.materialVariants] = [];
        }
      });
      this.group.querySelectorAll('[data-material-id]').forEach(input => {
        input.disabled = input.dataset.materialId !== 'vinyl' && !this.variants[input.dataset.materialId]?.length;
      });
      this.form?.addEventListener('submit', event => {
        if (!this.requiresQuote() && this.form.querySelector('[name="id"]')?.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    }

    material() {
      return this.group.querySelector('[data-material-id]:checked')?.dataset.materialId || 'vinyl';
    }

    requiresQuote() {
      return this.material() !== 'vinyl' && !this.variants[this.material()]?.length;
    }

    money(cents) {
      return new Intl.NumberFormat('en', {
        style: 'currency', currency: this.currency, currencyDisplay: 'code',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100).replace(/\u00a0/g, ' ');
    }

    variantFor(variant, selection) {
      const material = selection.material || this.material();
      if (material === 'vinyl') return variant;
      return this.variants[material]?.find(item =>
        String(item.option1 || item.options?.[0]) === String(selection.size)
        && String(item.option2 || item.options?.[1]) === String(selection.finish)
        && String(item.option3 || item.options?.[2]) === String(selection.quantity)
      ) || null;
    }

    update(selection, variant, variants) {
      const material = this.material();
      const quoted = this.requiresQuote();
      const base = this.variantFor(variants.find(item =>
        String(item.option1 || item.options?.[0]) === String(selection.size)
        && String(item.option2 || item.options?.[1]) === String(selection.finish)
        && String(item.option3 || item.options?.[2]) === String(selection.quantity)
      ), {...selection, material: 'vinyl'});
      this.group.querySelectorAll('[data-material-option]').forEach(option => {
        const candidate = this.variantFor(base, {...selection, material: option.dataset.materialOption});
        const delta = candidate && base ? Number(candidate.price) - Number(base.price) : null;
        option.querySelector('[data-material-delta]').textContent = option.dataset.materialOption === 'vinyl'
          ? this.strings.included
          : delta === null ? this.strings.unavailable : this.strings.upgrade.replace('{amount}', this.money(delta));
      });
      this.group.querySelector('[data-material-description]').textContent = this.strings[material + '_copy'];
      this.root.querySelector('[data-material-total-label]').textContent = this.strings.price;
      this.root.querySelector('[data-order-summary]').textContent += ' · ' + this.strings[material + '_name'];
      this.root.querySelector('[data-tier-summary]').textContent = '';
      const upload = this.root.querySelector('[data-ink-artwork-upload]');
      if (upload) upload.hidden = false;
      const checkout = this.root.querySelector('[data-native-checkout]');
      checkout.hidden = false;
      checkout.disabled = quoted || !variant || variant.available === false;
      checkout.setAttribute('aria-disabled', String(checkout.disabled));
      const footerNote = this.root.querySelector('.ink-native-calculator__checkout > small');
      if (footerNote) footerNote.hidden = false;
      const quote = this.root.querySelector('[data-material-quote]');
      if (quote) quote.hidden = true;
      this.group.querySelector('.ink-roll-materials__notice').textContent = this.strings.order_note;
    }
  }
  window.InkRollMaterials = InkRollMaterials;
})();
